/**
 * http请求catch时的拦截器（顺序拦截，可提前退出拦截）
 * - 处理白名单和黑名单
 * - 处理授权异常
 * - 统一接口异常错误码的逻辑处理
 * - 统一接口异常错误码toast提示
 *
 * @since 1.0.0
 * @version 1.0.0
 */

import _ from 'lodash'
// import authErrorInterceptor from './err-interceptor-auth'
import toastErrorInterceptor from './err-interceptor-toast'
import abnormalErrorInterceptor from './err-interceptor-abnormal'
import bodylErrorInterceptor from './err-interceptor-body'

/**
 * catch拦截器
 * 顺序拦截，可提前退出拦截
 *
 * @param {object} body - 响应体
 * @returns {object} - 新的 http 请求参数
 */
export default function errorInterceptor(body) {
  if (!body || !body.data) {
    return false
  }

  body = bodylErrorInterceptor(body)
  // 当检查到用户未授权时，提前结束后边的检测
  // if (!authErrorInterceptor(body)) {
  //   return false
  // }

  // 处理黑白名单，同时存在时白名单和黑名单时，以白名单为准（从白名单中移除黑名单的异常码）
  const { codeWhiteList, codeBlackList } = body.config.meta

  if (codeWhiteList.length > 0 && codeBlackList.length > 0) {
    body.config.meta.codeWhiteList = _.difference(codeWhiteList, codeBlackList)
    body.config.meta.codeBlackList = []
  }

  // 如果只存在白名单，则判断code是否在白名单中，如果存在，则忽略
  // 如果只存在黑名单，则判断code是否在黑名单中，如果不存在，则忽略
  // 都不存在时，正常处理
  if (
    body.config.meta.codeWhiteList.indexOf(body.data.code) > 0 ||
    (body.config.meta.codeBlackList.indexOf(body.data.code) < 0 && body.config.meta.codeBlackList.length > 0)
  ) {
    return false
  }
  // 异常错误码的统一异常处理(异常处理后，如果需要再弹toast的，则返回true)
  // 异常错误码的统一toast处理
  toastErrorInterceptor(body) && abnormalErrorInterceptor(body)

  return true
}
